import { combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

/* PLOP_INJECT_IMPORT */
import { reducer as appReducer } from './app/slice'
import { reducer as authReducer } from './auth/slice'
import { reducer as gameReducer } from './game/slice'
import { reducer as leagueReducer } from './league/slice'
import { reducer as teamReducer } from './team/slice'
import { reducer as tournamentReducer } from './tournament/slice'
import { reducer as notificationReducer } from './notification/slice'
import { reducer as newsReducer } from './news/slice'
import { reducer as becomeNodeReducer } from './becomeNode/slice'
import { reducer as gameServersReducer } from './gameServers/slice'
import walletReducer from './wallet/slice'

const persistAuthConfig = {
  key: 'auth',
  storage,
  // IMPORTANT: Never persist tokens - Privy manages authentication
  // This blacklist ensures old HS256 tokens are never persisted
  // isLoading is transient: persisting it let a mid-logout /me request leave
  // `isLoading: true` with no user, which hid the landing page (no Login button).
  blacklist: ['token', 'isLoading'],
  // Migrate old persisted state to remove tokens
  migrate: (state: any) => {
    if (state && state.token) {
      console.warn('🧹 Removing persisted token from old auth system')
      delete state.token
    }
    if (state && state.user && state.user.token) {
      console.warn('🧹 Removing persisted token from user object')
      delete state.user.token
    }
    return Promise.resolve(state)
  },
}

const persistedAuthReducer = persistReducer(persistAuthConfig, authReducer)

const rootReducer = combineReducers({
  /* PLOP_INJECT_REDUCER */
  team: teamReducer,
  app: appReducer,
  auth: persistedAuthReducer,
  game: gameReducer,
  league: leagueReducer,
  tournament: tournamentReducer,
  notification: notificationReducer,
  news: newsReducer, // Include news reducer in rootReducer
  node: becomeNodeReducer,
  gameServers: gameServersReducer,
  wallet: walletReducer,
})

export default rootReducer
